module.exports = __webpack_public_path__ + "img/anomaly-en.5a49db48.jpg";